import { render } from "./ListCustomers.vue?vue&type=template&id=007276d2"
import script from "./ListCustomers.vue?vue&type=script&lang=js"
export * from "./ListCustomers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__